/**
 * @generated SignedSource<<fcab78051437e096a64e44e35487df3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormQuestionInput = {
  addressDefinition?: CustomField__AddressInput | null;
  checkboxesDefinition?: CustomField__CheckboxesInput | null;
  checkboxesGridDefinition?: CustomField__CheckboxesGridInput | null;
  dateDefinition?: CustomField__DateInput | null;
  dateTimeDefinition?: CustomField__DateTimeInput | null;
  emailDefinition?: CustomField__EmailInput | null;
  formattedTextDefinition?: CustomField__FormattedTextInput | null;
  keywordsDefinition?: CustomField__KeywordsInput | null;
  linkDefinition?: CustomField__LinkInput | null;
  multipleChoiceDefinition?: CustomField__MultipleChoiceInput | null;
  multipleChoiceGridDefinition?: CustomField__MultipleChoiceGridInput | null;
  numericDefinition?: CustomField__NumericInput | null;
  phoneNumberDefinition?: CustomField__PhoneNumberInput | null;
  required: boolean;
  stringDefinition?: CustomField__StringInput | null;
  text: string;
  timeDefinition?: CustomField__TimeInput | null;
};
export type CustomField__AddressInput = {
  dummy?: boolean | null;
};
export type CustomField__CheckboxesInput = {
  options: ReadonlyArray<CustomField__CheckboxOptionInput>;
};
export type CustomField__CheckboxOptionInput = {
  text: string;
  value?: string | null;
};
export type CustomField__CheckboxesGridInput = {
  options: ReadonlyArray<CustomField__CheckboxesGridOptionInput>;
  rows: ReadonlyArray<CustomField__CheckboxesGridRowInput>;
};
export type CustomField__CheckboxesGridOptionInput = {
  text: string;
  value?: string | null;
};
export type CustomField__CheckboxesGridRowInput = {
  text: string;
  value?: string | null;
};
export type CustomField__DateInput = {
  maxDate?: any | null;
  minDate?: any | null;
};
export type CustomField__DateTimeInput = {
  maxDatetime?: ISO8601DateTimeString | null;
  minDatetime?: ISO8601DateTimeString | null;
};
export type CustomField__EmailInput = {
  maxLength?: number | null;
};
export type CustomField__FormattedTextInput = {
  maxLength?: number | null;
};
export type CustomField__KeywordsInput = {
  maxCount?: number | null;
};
export type CustomField__LinkInput = {
  maxLength?: number | null;
};
export type CustomField__MultipleChoiceInput = {
  options: ReadonlyArray<CustomField__MultipleChoiceOptionInput>;
};
export type CustomField__MultipleChoiceOptionInput = {
  text: string;
  value?: string | null;
};
export type CustomField__MultipleChoiceGridInput = {
  options: ReadonlyArray<CustomField__MultipleChoiceGridOptionInput>;
  rows: ReadonlyArray<CustomField__MultipleChoiceGridRowInput>;
};
export type CustomField__MultipleChoiceGridOptionInput = {
  text: string;
  value?: string | null;
};
export type CustomField__MultipleChoiceGridRowInput = {
  text: string;
  value?: string | null;
};
export type CustomField__NumericInput = {
  maxValue: number;
  minValue: number;
};
export type CustomField__PhoneNumberInput = {
  maxLength?: number | null;
  minLength?: number | null;
};
export type CustomField__StringInput = {
  maxLength?: number | null;
};
export type CustomField__TimeInput = {
  maxTime?: TimeOfDayString | null;
  minTime?: TimeOfDayString | null;
};
export type EditForm_createQuestion_Mutation$variables = {
  formId: string;
  questions: ReadonlyArray<FormQuestionInput>;
};
export type EditForm_createQuestion_Mutation$data = {
  readonly createMultipleQuestions: {
    readonly form: {
      readonly " $fragmentSpreads": FragmentRefs<"EditForm_form">;
    };
  } | null;
};
export type EditForm_createQuestion_Mutation = {
  response: EditForm_createQuestion_Mutation$data;
  variables: EditForm_createQuestion_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "formId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "questions"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "formId",
        "variableName": "formId"
      },
      {
        "kind": "Variable",
        "name": "questions",
        "variableName": "questions"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditForm_createQuestion_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsCreateMultipleQuestionsMutationPayload",
        "kind": "LinkedField",
        "name": "createMultipleQuestions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "form",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditForm_form"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditForm_createQuestion_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsCreateMultipleQuestionsMutationPayload",
        "kind": "LinkedField",
        "name": "createMultipleQuestions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "form",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClosed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormQuestion",
                "kind": "LinkedField",
                "name": "questions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "definition",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "maxValue",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomField__Numeric",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "CustomField__Checkboxes",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "CustomField__MultipleChoice",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "required",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90259fbfa4f4f9ac2f20e939e11c5317",
    "id": null,
    "metadata": {},
    "name": "EditForm_createQuestion_Mutation",
    "operationKind": "mutation",
    "text": "mutation EditForm_createQuestion_Mutation(\n  $formId: ID!\n  $questions: [FormQuestionInput!]!\n) {\n  createMultipleQuestions(input: {formId: $formId, questions: $questions}) {\n    form {\n      ...EditForm_form\n      id\n    }\n  }\n}\n\nfragment EditForm_form on Form {\n  id\n  isClosed\n  questions {\n    id\n    ...EditQuestionCard_formQuestion\n  }\n}\n\nfragment EditQuestionCard_formQuestion on FormQuestion {\n  id\n  ...QuestionTitle_question\n  ...QuestionInputs_question\n  ...QuestionControls_question\n}\n\nfragment QuestionControls_question on FormQuestion {\n  id\n  text\n  required\n  definition {\n    __typename\n    ... on CustomField__String {\n      id\n    }\n    ... on CustomField__Numeric {\n      minValue\n      maxValue\n    }\n    ... on CustomField__Checkboxes {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__MultipleChoice {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__Date {\n      id\n    }\n    ... on CustomField__Time {\n      id\n    }\n    ... on CustomField__DateTime {\n      id\n    }\n    ... on CustomField__PhoneNumber {\n      id\n    }\n    ... on CustomField__Email {\n      id\n    }\n    ... on CustomField__Link {\n      id\n    }\n    id\n  }\n}\n\nfragment QuestionInputs_question on FormQuestion {\n  id\n  definition {\n    __typename\n    ... on CustomField__String {\n      id\n    }\n    ... on CustomField__Numeric {\n      minValue\n      maxValue\n    }\n    ... on CustomField__Checkboxes {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__MultipleChoice {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__Date {\n      id\n    }\n    ... on CustomField__Time {\n      id\n    }\n    ... on CustomField__DateTime {\n      id\n    }\n    ... on CustomField__PhoneNumber {\n      id\n    }\n    ... on CustomField__Email {\n      id\n    }\n    ... on CustomField__Link {\n      id\n    }\n    id\n  }\n}\n\nfragment QuestionTitle_question on FormQuestion {\n  id\n  text\n  definition {\n    __typename\n    ... on CustomField__String {\n      id\n    }\n    ... on CustomField__Numeric {\n      minValue\n      maxValue\n    }\n    ... on CustomField__Checkboxes {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__MultipleChoice {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__Date {\n      id\n    }\n    ... on CustomField__Time {\n      id\n    }\n    ... on CustomField__DateTime {\n      id\n    }\n    ... on CustomField__PhoneNumber {\n      id\n    }\n    ... on CustomField__Email {\n      id\n    }\n    ... on CustomField__Link {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0b4c6f58d51d7c0aa73e31435638ca9";

export default node;
